import { useTranslation } from 'react-i18next'

import NewModal from '../root/modals/NewModal'
import AttachmentsExplorer from './AttachmentsExplorer'

const AttachmentsViewModal = ({ files, isOpen, setIsOpen }) => {
  const { t } = useTranslation()

  return (
    <NewModal setShowModal={setIsOpen} showModal={isOpen} title={t('support.detail.view_attachments')} page="report">
      {files.length ? (
        <AttachmentsExplorer files={files} />
      ) : (
        <div className="py-8 text-center text-slate-600">{t('support.detail.no_attachments')}</div>
      )}
    </NewModal>
  )
}

export default AttachmentsViewModal
